import { mapState } from 'vuex'
import filter from 'js/filter'
import { getTicketList, paypalAddOrder } from '@/service/vbef'
import { editXuserChannelByLocalShareChannelId } from 'js/shareChannel'
import {
  Alogin
} from '@/service/app'
import CardPay from '@/components/common/cardPay.vue'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
const signUpMixins = {
  components: { CardPay },
  data() {
    const _this = this
    return {
      filter,
      ticketList: [],
      concurrentList: {
        'zh': [
          `分论坛1：基因治疗临床转化及全球商业化论坛`,
          `分论坛2：下一代基因治疗与创新递送技术论坛`,
          `分论坛3：基因编辑技术与治疗创新论坛`,
          `分论坛4：In Vivo 细胞治疗在病毒载体递送中的研发与成药路径`,
          `分论坛5：In Vivo 细胞治疗在非病毒载体递送中的技术突破与成药路径`,
          `分论坛6：In Vivo 细胞治疗的临床验证与适应症开发策略`,
          `分论坛7：体外免疫细胞治疗在肿瘤和自免中的技术验证与临床突破`,
          `分论坛8：体外免疫细胞治疗的临床与商业化落地`,
          `分论坛9：星辰大海，扬帆起航，iPSC衍生细胞药物`,
          `分论坛10：干细胞药物的产业进程：创新研发、临床突破与规模化发展`,
          `分论坛11：外泌体药物的创新路径：监管科学引领下的药物开发与质量标准建立`,
          `分论坛12：小核酸药物的递送突破与临床新策略`,
          `分论坛13：个体化 VS 现货型：肿瘤疫苗双轨并行下的技术抉择与临床验证`,
          `分论坛14：828新政下CGT产品质控与检测的最新要求与替代方法`,
          `分论坛15：818备案“通关”全攻略：从方案设计到落地执行的全流程质控与合规路径`,
          `分论坛16：AI前沿技术突破——下一代算法架构与科学智能`,
          `分论坛17：AI赋能产业升级——从技术工具到核心生产力`,
          `分论坛18：创新方法评价（NAMs）论坛——聚焦类器官赋能科研创新、药物评价与临床转化`,
          `分论坛19：CGT中国资产的核心价值——投融资趋势与BD合作新逻辑`,
          `分论坛20：罕见病治疗：从科研创新到患者可及论坛`,
          `分论坛21：聚势共生——全球CGT网络的协同进化与多边合作`,
          `分论坛22：中国IIT与临床转化：医企协同构建全球研发新支点`,
          `分论坛23：女性领导力私享会`,
          `药企营销的龙虾配置实战（收费闭门会）`,
          `大会活动：项目路演`,
          `大会活动：中国IIT资源对接会`,
          `大会活动：CGT海外BD资源对接会`,
          `颁奖盛宴：CSGCT”创新之星“颁奖典礼暨晚餐交流会`,
          `大会活动：CSGCT欢迎晚宴`,
          `大会活动：CSGCT鸡尾酒晚会`,
          `大会活动：中国三甲医院生物医学新技术深度考察团`
        ],
        'en': [
          `Main Forum: Unlocking China's Clinical and Regulatory Momentum to Accelerate Global CGT Translation`,
          `Session 1: Translation & Global Commercialization of Gene Therapy`,
          `Session 2: Next-Generation Gene Therapy & Delivery Technologies Forum`,
          `Session 3: Genome Editing Technologies & Therapeutic Innovation Forum`,
          `Session 4: In Vivo Cell Therapy: R&D and Drug-Development Pathways for Viral Vector Delivery`,
          `Session 5: In Vivo Cell Therapy: Technology Breakthroughs and Drug-Development Pathways for Non-Viral Vector Delivery`,
          `Session 6: In Vivo Cell Therapy: Clinical Validation and Indication-Development Strategy`,
          `Session 7: Ex Vivo Immune Cell Therapies: Technology Validation and Clinical Breakthroughs in Oncology and Autoimmune Diseases`,
          `Session 8: Ex Vivo Immune Cell Therapies: Clinical Translation and Commercialization`,
          `Session 9: Clinical Breakthroughs and Diverse Innovations in iPSC-Derived Cell Therapies`,
          `Session 10: Advancing Stem Cell Therapies: Innovation, Clinical Breakthroughs, and Commercial Scale-Up`,
          `Session 11: Innovating Exosome Therapies: Drug Development and Quality Standards Guided by Regulatory Science`,
          `Session 12: Oligonucleotide Therapeutics: Delivery Advances and Emerging Clinical Strategies`,
          `Session 13: Personalized vs. Off-the-Shelf: Technology Choices and Clinical Validation of Cancer Vaccines on Dual Tracks`,
          `Session 14: Quality Control and Testing of CGT Products: New Regulatory Requirements and Alternative Methods`,
          `Session 15: Mastering the 818 Filing Process: From Protocol Design to Quality Control and Regulatory Compliance`,
          `Session 16: AI Frontiers: Next-Generation AI Architectures and Scientific Intelligence`,
          `Session 17: AI for Industry: From Productivity Tools to Strategic Business Value`,
          `Session 18: New Approach Methodologies (NAMs): Organoids for Research Innovation, Drug Evaluation, and Clinical Translation`,
          `Session 19: The Investment Value of China's CGT Assets: Trends and New BD Partnership Models`,
          `Session 20: Rare Disease Therapies: From Discovery to Patient Access`,
          `Session 21: United in Synergy: The Global CGT Forum for Co-Evolution & Multilateral Cooperation`,
          `Session 22: China's IITs and Clinical Practice: An Emerging Global Benchmark`,
          `Session 23: Women in Leadership Private Salon`,
          `Closed-Door Session: Practical Approaches to Pharma Marketing Team Structuring`,
          `Conference Activity: Project Pitch Session`,
          `Conference Activity: China IIT Resource Matchmaking Session`,
          `Conference Activity: CGT Overseas BD Networking Session`,
          `Conference Activity: CSGCT Innovation Awards Ceremony & Networking Dinner`,
          `Conference Activity: CSGCT Welcome Dinner`,
          `Conference Activity: CSGCT Cocktail Reception`,
          `Conference Activity: Chinese Top Tertiary Hospitals Biomedical Innovation VIP Delegation`
        ]
      },
      companyprofileother: false,
      companyProfileList: [
        filter.dealLanguage('大型药企', 'Big Pharma'),
        filter.dealLanguage('CGT 创新药企', 'CGT Innovative Pharmaceutical Company '),
        filter.dealLanguage('投资机构（人民币）', 'Investment Agency (RMB Fund)'),
        filter.dealLanguage('投资机构（美元）', 'Investment Agency (USD Fund)'),
        filter.dealLanguage('临床前CRO企业 ', 'Pre-clinical CRO'),
        filter.dealLanguage('临床CRO企业 ', 'Clinical CRO '),
        filter.dealLanguage('CMO/CDMO企业', 'CMO/CDMO'),
        filter.dealLanguage(
          '供应链产品企业（原材料、试剂耗材、仪器设备等）',
          'Supply-Chain Solutions Provider(APIs、Reagent & Consumable Materials、Instrument & Equipment,etc.)'
        ),
        filter.dealLanguage('第三方检测服务企业', 'Testing Service Provider'),
        filter.dealLanguage('细胞存储企业', 'Cell Storage Services'),
        filter.dealLanguage(
          '国际业务服务企业（金融机构、律所等）',
          'Global Business Services(Financial Institution, Law Firm, etc.)'
        ),
        filter.dealLanguage('科研院所/高校', 'Academic & Research Institution/University'),
        filter.dealLanguage('医院/临床机构', 'Hospital/clinical institution'),
        filter.dealLanguage('监管机构/行业协会', 'Regulators/Industry Association'),
        filter.dealLanguage(
          '产业园区/孵化器/加速器等 ',
          'Industrial Park/Incubator/Accelerator, etc.'
        ),
        filter.dealLanguage('患者组织 ', 'Patient Group'),
        filter.dealLanguage('其他，请填写 ', 'Others, please specify'),
      ],
      currentAddressDto: [],
      addressDtoList: [],
      addressDtos: [],
      ruleValidate2: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        compName: [
          {
            required: true,
            message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'),
            trigger: 'change',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        addressId: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyProfile: [
          {
            required: true,
            message: filter.dealLanguage('请选择公司性质', 'Please select'),
            trigger: 'change',
          },
        ],
        whether: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyprofileother: [
          {
            required: true,
            message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'),
            trigger: 'blur',
          },
        ],
        concurrent2: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage('请选择会议或活动', 'Please select a meeting or event'),
            trigger: 'change',
          },
        ],
        need2: [
          {
            required: true,
            max: 3,
            min: 3,
            type: 'array',
            message: filter.dealLanguage(
              '请选出最重要的3项需求',
              'Please select the top 3 requirements'
            ),
            trigger: 'change',
          },
        ],
        service2: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketName: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketNameEn: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入验证码',
              'Please enter the verification code'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateCode
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的邮箱', 'Please enter your E-mail'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The E-mail format is incorrect'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
      },
      paymentWay: 1,
      isVerifyCode: false
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      user: (state) => state.user,
      isWeixinBrowser: (state) => state.isWeixinBrowser,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
      language: (state) => state.language,
      isMobile: (state) => state.isMobile,
      channelDiscountRate: (state) => state.channelDiscountRate,
    }),
  },
  methods: {
    ininUserInfo() {
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = user.mobile || ''
      this.currentForm.mobileAreaCode = user.mobileAreaCode || ''
      this.currentForm.email = user.email.includes('@privaterelay.appleid.com') ? '' : (user.email || '')
      if (this.wxCode) this.genOpenidByWechatCode()
    },
    async getTicketList() {
      let res = await getTicketList({
        actId: this.activityId,
        payType: this.language == 'zh' ? 1 : 2,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'ticketList', res.data)
        if (res.data.length) {
          this.currentTicket = res.data[0]
          this.currentForm.activityTicketId = res.data[0].id
        }
      }
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value || !this.companyNatureTags.length) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (
        item.name.indexOf('其他') > -1 ||
        item.name.indexOf('Other') > -1 ||
        item.name.indexOf('other') > -1
      ) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    submitEn() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          const orderParams = this.setOrderParams()
          if (this.paymentWay == 1 && this.currentTicket.price) {
            const formParams = {
              email: this.currentForm.email,
            }
            this.$refs['card-pay'].handlePay(orderParams, formParams)
            return
          }
          let res = await paypalAddOrder(orderParams)
          this.buttonLoading = false
          if (res.code == 0) {
            if (res.data.activityTicketUserRelationId) {
              this.$router.push({
                name: 'ticketDetail',
                params: { id: res.data.activityTicketUserRelationId }
              })
            }
            if (res.data.paypalUrl) {
              window.location.href = res.data.paypalUrl
            }
          } else {
            if (this.isMobile) {
              this.$notify(res.enMsg || res.msg)
            } else {
              this.$Message.error(res.enMsg || res.msg)
            }
          }
        } else {
          if (this.isMobile) {
            this.$notify('Please complete the form and submit it')
          } else {
            this.$Message.error('Please complete the form and submit it')
          }

        }
      })
    },
    setOrderParams() {
      let { activityTicketId, ...params } = this.currentForm
      let ticketParamsStr = JSON.stringify(params)
      return {
        activityTicketId: activityTicketId,
        checkFormJson: ticketParamsStr,
        loginPlatform: this.isMobile ? 9 : 8,
        payType: 4,
      }
    },
    handleSelectPaymentOption(value) {
      this.paymentWay = value
    },
    updateLoading(loading) {
      this.buttonLoading = loading
    },
    async validateCode(rule, value, callback) {  // 2手机号 11 邮箱登录
      if (this.isVerifyCode) {
        callback()
        return
      }

      let params = {
        loginPlatform: this.isMobile ? 9 : 8,
        type: this.language == 'zh' ? 2 : 11,
        email: this.currentForm.email || '',
        mobileAreaCode: this.currentForm.mobileAreaCode || '',
        mobile: this.currentForm.mobile || '',
        code: this.currentForm.verifyCode,
      }
      let res = await Alogin(params)
      if (res.code == 0) {
        this.$store.commit('updateUserKey', res.data.userKey)
        this.isVerifyCode = true
        if (this.wxCode) this.genOpenidByWechatCode()
        editXuserChannelByLocalShareChannelId(this.$store.state.activityId)
        callback()
      } else {
        this.$store.commit('updateUserKey', null)
        this.isVerifyCode = false
        callback(new Error(filter.dealLanguage(
          res.msg,
          res.enMsg
        )));
      }
    },
    handleUpdateMobile() {
      this.$store.commit('updateUserKey', null)
      this.isVerifyCode = false
      this.currentForm.mobile = ''
      this.currentForm.verifyCode = ''
      this.currentForm.email = ''
    }
  },
}
export { signUpMixins }
